<template>
  <div>
    <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 0.5rem;">
      <b-card style="grid-row: 1;" header="Documentation">
        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.customerPNConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.customerPN" :disabled="isShipping"></b-form-checkbox>
          <a>Requires CustomerPN on all Forms</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.harmonizedCodeConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.harmonizedCode" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Harmonized Code</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.cooConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.coo" :disabled="isShipping"></b-form-checkbox>
          <a>Requires COO</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.cofcConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.cofc" :disabled="isShipping"></b-form-checkbox>
          <a>Requires CofC</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.manufacturersCOFCConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.manufacturersCOFC" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Manufacturer CofC</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.dataSheetsConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.dataSheets" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Datasheets</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.imagesConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.images" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Images</a>
        </div>
      </b-card>

      <b-card style="grid-row: 1/3;" header="Package Requirement">
        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.contractNoConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.contractNo" :checked="isShipping" :disabled="isShipping"></b-form-checkbox>
          <a>ContractNo/PONo on Box</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.barcodeLabelConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.barcodeLabel" :checked="isShipping" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Barcode Labels</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.individualPackageConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.individualPackage" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Individual Packaging</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.rfidLabelConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.rfidLabel" :disabled="isShipping"></b-form-checkbox>
          <a>Requires RFID Labels</a>
        </div>
      </b-card>

      <b-card style="grid-row: 1/3;" header="Logistics">
        <b-row>
          <b-col cols="5" class="col-form-label">Always Ship By</b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-select v-model="orderFulfillmentCloned.alwaysShipBy" @change="onValueChange('alwaysShipBy')">
                <option></option>
                <option value="1">Customer</option>
                <option value="2">House Account</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5" class="col-form-label pt-0">Shipping Provider</b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-select v-model="orderFulfillmentCloned.shippingProviderId" @change="onShippingAccountChange(true); onValueChange('shippingProviderId')">
                <option v-for="(select, index) in sortSelect(shippingProviders)" :key="index" :value="select.id">
                  {{ select.name }}
                </option>
              </b-form-select>
          </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5" class="col-form-label pt-0">Shipping Method</b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-select v-model="orderFulfillmentCloned.shippingMethodId" @change="onValueChange('shippingMethodId')">
                <option v-for="(select, index) in sortSelect(shipMethods)" :key="index" :value="select.id">{{ select.name }}
                </option>
              </b-form-select>
          </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5" class="col-form-label pt-0">Account No</b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-input v-model="orderFulfillmentCloned.shippingAccountNumber" class="flex-one" @change="onShippingAccountChange(false); onValueChange('shippingAccountNumber')"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <br/>
        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.doNotInsureConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.doNotInsure" :disabled="isShipping"></b-form-checkbox>
          <a>Do not Insure or Declare Value</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.requestImmediateTrackingNoConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.requestImmediateTrackingNo" :disabled="isShipping"></b-form-checkbox>
          <a>Requests Immediate Tracking Number</a>
        </div>
      </b-card>

      <b-card style="grid-row: 1/3;" :header="isShipping ? 'Special Instructions' : 'Shipping Notes'">
        <div class="d-flex">
          <b-form-textarea
            v-model="orderFulfillmentCloned.shippingNotes"
            rows="4"
            @change="onValueChange('shippingNotes')"
          ></b-form-textarea>
        </div>
      </b-card>

      <b-card header="Quality Control">
        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.requestThirdPartyTestLabConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.requestThirdPartyTestLab" :disabled="isShipping"></b-form-checkbox>
          <a>Requires 3rd Party TestLab Report</a>
        </div>

        <div class="d-flex">
          <b-form-checkbox v-if="isShipping" v-model="shippingFulfillment.requestInspectionReportConfirmed"></b-form-checkbox>
          <b-form-checkbox v-model="orderFulfillmentCloned.requestInspectionReport" :disabled="isShipping"></b-form-checkbox>
          <a>Requires Inspection Report</a>
        </div>
      </b-card>
    </div>
    <b-button class="mt-2" variant="primary" @click="onSaveOrderFulfillment" v-if="!isShipping" :disabled="isSaving">
      <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    isShipping: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [Number, String],
      default: 0
    },
    invoiceFulfillment: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      shippingProviderVal: 0,
      orderFulfillmentCloned: {},
      shippingFulfillment: {},
      isSaving:false,
    }
  },
  computed: {
    ...mapGetters('shippingAccount', ['shippingAccountsList']),
    ...mapState('companies', ['orderFulfillment']),
    ...mapState('shippingproviders', ['shippingproviders']),
    ...mapGetters('lookup', ['shippingProviders', 'shipViaList']),
    shipMethods() {
      if (this.orderFulfillmentCloned.shippingProviderId) {
        return this.shipViaList.filter(ship => ship.shippingProviderId == this.orderFulfillmentCloned.shippingProviderId);
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapActions('companies', [
      'getOrderFulfillment',
      'createOrderFulfillment',
      'updateOrderFulfillment',
    ]),
    ...mapActions('shippingAccount', ['getShippingAccounts']),
    // ...mapActions('shippingproviders', {
    //   getAllShippingProviders: 'getAll',
    // }),
    async onSaveOrderFulfillment() {
      try {
        this.isSaving = true;
        if (this.orderFulfillmentCloned.id === 0) {
          await this.createOrderFulfillment(this.orderFulfillmentCloned);
        } else {
          await this.updateOrderFulfillment(this.orderFulfillmentCloned);
        }
        this.isSaving = false;
        await this.getOrderFulfillment(this.companyId);

        this.orderFulfillmentCloned = {...this.orderFulfillment};
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    onValueChangeOrderFulfillment({ value }) {
      this.orderFulfillmentCloned.shippingProviderId = value;
    },
    onValueChange(key) {
      if (this.isShipping) {
        this.shippingFulfillment[key + 'Confirmed'] = true;
      }
    },
    onShippingAccountChange(isProviderChange = false) {
      if (isProviderChange) {
        this.orderFulfillmentCloned.shippingMethodId = 0
      }
      // If ship by is Customer
      if (this.orderFulfillmentCloned.alwaysShipBy == 1) {
        const acct = this.shippingAccountsList.find(x => x.shippingProviderId == this.orderFulfillmentCloned.shippingProviderId);
        this.orderFulfillmentCloned.shippingAccountNumber = (acct != null) ? acct.accountNumber : null;
      } else {
        this.orderFulfillmentCloned.shippingAccountNumber = null;
      }
    }
  },
  watch: {
    // shippingFulfillment() {
    //
    //   console.log(this.shippingFulfillment);
    //
    //   this.$emit('onFulfillmentChange', this.shippingFulfillment);
    // },
    shippingFulfillment: {
      handler(val){
        this.$emit('onFulfillmentChange', val);
      },
      deep: true
    }
  },
  async mounted() {
    await this.getOrderFulfillment(this.companyId);

    this.orderFulfillmentCloned = { ...this.orderFulfillment };

    if (this.orderFulfillmentCloned.companyId) {
      this.getShippingAccounts(this.orderFulfillmentCloned.companyId);
    }
    if (this.isShipping) {
      // this.shippingFulfillment = this.invoiceFulfillment;
      this.shippingFulfillment = Object.assign({}, this.invoiceFulfillment);
      let sFId = this.shippingFulfillment.id || 0
      this.shippingFulfillment = { ...this.shippingFulfillment, ...this.orderFulfillment, id: sFId };
    }

  }
}
</script>
